module.exports = __webpack_public_path__ + "static/media/Facebook messenger.0008f04f.svg";